<template>
  <div class="tw-w-full tw-p-0">
    <div class="tw-p-2 tw-justify-between colapse-area colapse tw-flex tw-w-full">
      <div class="tw-flex tw-items-center tw-ml-2">
        <span class="tw-font-medium">{{ $gettext('BILLINGS') }}</span>
        <span class="tw-ml-2 tw-bg-white tw-text-blue-700 tw-rounded-full tw-px-2 tw-text-sm tw-font-bold">{{ count }}</span>
      </div>
      <div class="tw-flex-1"></div>
      <div>
        <q-btn flat icon="mdi-arrow-collapse-vertical" class="tw-text-warmGray-100" @click="openCloseTable">
          <q-tooltip anchor="top middle" self="bottom middle">{{ $gettext('EXPAND') }}</q-tooltip>
        </q-btn>
      </div>
    </div>
    <div class="tw-pb-4"></div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'HeaderColapseInvoices',
  props: {
    count: { type: Number, default: 0 }
  }
})
class HeaderColapseInvoices extends Vue {
  openCloseTable () {
    this.$emit('colapse')
  }
}
export default HeaderColapseInvoices
</script>

<style lang="scss" scoped>
@import "tailwindcss/utilities";

.colapse-area {
  background-color: #5898aa;
  display: flex;
}

.colapse {
  color: #fff;
}
</style>
